'use strict';
const _ = require('underscore'),
	buildDeferred = function () {
		const deferred = {};
		deferred.promise = new Promise((resolve, reject) => {
			deferred.resolve = resolve;
			deferred.reject = reject;
		});
		return deferred;
	},
	allowedImageTypes = require('./allowed-image-types');

module.exports = function GooglePicker(config, googleContainer) {
	const obj = this,
		launch = function (picker, authToken, title, deferred) {
			// if (navigatorShim.hasWindowFlag('cookieCheck')) {
			picker.setAppId(config.googleAppId)
				.setTitle(title)
				.setOrigin(googleContainer.location.origin)
				.setOAuthToken(authToken)
				.build().setVisible(true);
			return deferred.promise;
			// } else {
			// 	if (pageController) {
			// 		pageController.dispatchEvent('cookies-blocked');
			// 	}
			// 	return Promise.reject('cookies-blocked');
			// }
		},
		getTokenFromProfile = (profile) => profile && profile.providerProfile && profile.providerProfile.token;
	obj.pickImage = function (profile, title) {
		const deferred = buildDeferred(),
			authToken = getTokenFromProfile(profile),
			google = googleContainer.google,
			thumbArea = function (thumb) {
				return thumb.height * thumb.width;
			},
			mimeTypes = ['application/vnd.google-apps.photo'].concat(allowedImageTypes).join(','),
			uploadView = new google.picker.DocsUploadView(),
			listView =  new google.picker.DocsView(google.picker.ViewId.DOCS_IMAGES),
			teamListView = new google.picker.DocsView(google.picker.ViewId.DOCS_IMAGES),
			picker = new google.picker.PickerBuilder(),
			callback = function (choice) {
				let item, url;
				if (choice.action === 'picked') {
					item = choice.docs[0];
					url = item.thumbnails && _.sortBy(item.thumbnails, thumbArea).pop().url;
					if (url) {
						deferred.resolve({url, item});
					} else if (item.mimeType.startsWith('image/')) {
						deferred.resolve({item});
					} else {
						deferred.reject();
					}
					return;
				}
				if (choice.action === 'cancel') {
					deferred.reject();
				}
			};

		listView.setMode(google.picker.DocsViewMode.GRID);
		listView.setIncludeFolders(true);
		listView.setMimeTypes(mimeTypes);
		teamListView.setMode(google.picker.DocsViewMode.GRID);
		teamListView.setIncludeFolders(true);
		teamListView.setEnableTeamDrives(true);
		teamListView.setMimeTypes(mimeTypes);
		uploadView.setIncludeFolders(true);
		uploadView.setMimeTypes(mimeTypes);


		picker.disableFeature(google.picker.Feature.MULTISELECT_ENABLED)
			.enableFeature(google.picker.Feature.SUPPORT_DRIVES)
			.addView(listView)
			.addView(teamListView)
			.addView(uploadView)
			.setSelectableMimeTypes(mimeTypes)
			.setCallback(callback);

		return launch(picker, authToken, title, deferred);
	};
	obj.pickFileForImport = function (profile, title, callOptions) {
		let picker = false;
		const deferred = buildDeferred(),
			authToken = getTokenFromProfile(profile),
			google = googleContainer.google,
			uploadView = new google.picker.DocsUploadView(),
			listView =  new google.picker.DocsView(google.picker.ViewId.DOCS),
			teamListView = new google.picker.DocsView(google.picker.ViewId.DOCS);

		listView.setMode(google.picker.DocsViewMode.LIST);
		listView.setIncludeFolders(true);

		teamListView.setMode(google.picker.DocsViewMode.LIST);
		teamListView.setIncludeFolders(true);
		teamListView.setEnableTeamDrives(true);

		uploadView.setIncludeFolders(true);
		picker = new google.picker.PickerBuilder()
			.enableFeature(google.picker.Feature.SIMPLE_UPLOAD_ENABLED)
			.enableFeature(google.picker.Feature.SUPPORT_TEAM_DRIVES);

		if (callOptions && callOptions.mimeTypes) {
			picker.setSelectableMimeTypes(callOptions.mimeTypes);
			listView.setMimeTypes(callOptions.mimeTypes);
			teamListView.setMimeTypes(callOptions.mimeTypes);
		}

		if (callOptions && callOptions.multiSelect) {
			picker.enableFeature(google.picker.Feature.MULTISELECT_ENABLED);
		} else {
			picker.disableFeature(google.picker.Feature.MULTISELECT_ENABLED);
		}

		picker.addView(teamListView)
			.addView(listView);
		if (!(callOptions && callOptions.disableUpload)) {
			picker.addView(uploadView);
		}
		picker.setCallback((choice) => {
			if (choice.action === 'picked') {
				if (choice.docs.length) {
					if (callOptions && callOptions.multiSelect) {
						deferred.resolve(choice.docs);
					} else {
						deferred.resolve(choice.docs[0]);
					}

				} else {
					deferred.reject();
				}
				return;
			}
			if (choice.action === 'cancel') {
				deferred.reject();
			}
		});
		return launch(picker, authToken, title, deferred);
	};
	obj.pickFile = function (profile, title) {
		let picker = false;
		const deferred = buildDeferred(),
			authToken = getTokenFromProfile(profile),
			google = googleContainer.google,
			uploadView = new google.picker.DocsUploadView(),
			listView =  new google.picker.DocsView(google.picker.ViewId.DOCS),
			teamListView =  new google.picker.DocsView(google.picker.ViewId.DOCS);

		listView.setMode(google.picker.DocsViewMode.LIST);
		listView.setIncludeFolders(true);

		teamListView.setMode(google.picker.DocsViewMode.LIST);
		teamListView.setIncludeFolders(true);
		teamListView.setEnableTeamDrives(true);

		uploadView.setIncludeFolders(true);
		picker = new google.picker.PickerBuilder()
			.enableFeature(google.picker.Feature.SIMPLE_UPLOAD_ENABLED)
			.enableFeature(google.picker.Feature.SUPPORT_TEAM_DRIVES)
			.disableFeature(google.picker.Feature.MULTISELECT_ENABLED)
			.addView(teamListView)
			.addView(listView)
			// .addView(google.picker.ViewId.VIDEO_SEARCH)
			// .addView(google.picker.ViewId.YOUTUBE)
			.addView(uploadView)
			.setCallback((choice) => {
				if (choice.action === 'picked') {
					if (choice.docs[0]) {
						deferred.resolve(choice.docs[0]);
					} else {
						deferred.reject();
					}
					return;
				}
				if (choice.action === 'cancel') {
					deferred.reject();
				}
			});
		return launch(picker, authToken, title, deferred);
	};
	//2017-10-16 moving realtime files betweeen personal and team drives still not supported in Google drive (check their web interface first)
	//
	obj.pickFolder = function (profile, title) {
		let picker = false;
		const deferred = buildDeferred(),
			google = googleContainer.google,
			authToken = getTokenFromProfile(profile),
			folderMime = 'application/vnd.google-apps.folder',
			initView = function () {
				const view = new google.picker.DocsView(google.picker.ViewId.FOLDERS);
				view.setMode(google.picker.DocsViewMode.LIST);
				view.setIncludeFolders(true);
				view.setSelectFolderEnabled(true);
				view.setMimeTypes(folderMime);
				return view;
			},
			listView = initView();
			//teamListView = initView();

		//teamListView.setEnableTeamDrives(true);

		picker = new google.picker.PickerBuilder()
			.enableFeature(google.picker.Feature.SUPPORT_TEAM_DRIVES)
			.disableFeature(google.picker.Feature.MULTISELECT_ENABLED)
			//.addView(teamListView)
			.addView(listView)
			.setSelectableMimeTypes(folderMime)
			.setCallback((choice) => {
				if (choice.action === 'picked') {
					if (choice.docs[0] && choice.docs[0].id) {
						deferred.resolve(choice.docs[0].id);
					} else {
						deferred.reject();
					}
					return;
				}
				if (choice.action === 'cancel') {
					deferred.reject();
				}
			});
		return launch(picker, authToken, title, deferred);
	};
};
